import { PillIntent } from '@/_components';
import { DocumentsColumnType } from '@/_types/documents';
import { ExtractedDocumentItem } from '@/_types/models/documents';

// Storage
export const S3_DOMAIN = 'amazonaws.com' as const;
export const DROPBOX_DOMAIN = 'dropbox.com' as const;
// TODO @chris should come from env
export const S3_BASE_PATH =
  'https://soraban-documents-dev.s3.us-west-2.amazonaws.com' as const;

export const DOCUMENT_ANSWER_PREFIX = '$$attached$$' as const;

export const DOCUMENTS_TABLE_HEADER_MAP: Record<DocumentsColumnType, string> = {
  actions: '',
  select: 'Select',
  name: 'Name',
  description: 'Description',
  tags: 'Tags',
  size: 'Size',
  updated_at: 'Last Modified',
  created_at: 'Uploaded',
};

export const EXTRACTED_COLOR_MAP: Record<
  ExtractedDocumentItem['status'],
  PillIntent
> = {
  identify_failed: 'danger',
  processing: 'info',
  identify_succeeded: 'success',
  split_succeeded: 'success',
  split_failed: 'danger',
  review_required: 'warning',
};

export const EXTRACTED_TEXT_MAP: Record<
  ExtractedDocumentItem['status'],
  string
> = {
  processing: 'Processing',
  identify_failed: 'Identify Failed',
  identify_succeeded: 'Identified',
  split_succeeded: 'Split Succeeded',
  split_failed: 'Split Failed',
  review_required: 'Review Required',
};
